import apiClient, { API_ENDPOINTS, rejectWithError } from "api";

const { inquiry } = API_ENDPOINTS;

export const createInquiry = async (inquiryPayload) => {
  try {
    return await apiClient.post(inquiry.createInquiry, inquiryPayload);
  } catch (error) {
    return rejectWithError(error, "Error creating inquiry");
  }
};
